import { render, staticRenderFns } from "./ViewCategory.vue?vue&type=template&id=4c915164"
import script from "./ViewCategory.vue?vue&type=script&lang=js"
export * from "./ViewCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports